var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAccountPopupBilling = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#EBEBEB",
  d: "M20 2v12q0 .825-.587 1.413A1.93 1.93 0 0 1 18 16H2q-.824 0-1.412-.587A1.93 1.93 0 0 1 0 14V2Q0 1.176.588.588A1.92 1.92 0 0 1 2 0h16q.825 0 1.413.588Q20 1.175 20 2M2 4h16V2H2zm0 4v6h16V8zm0 6V2z"
})));
export default SvgAccountPopupBilling;